module.exports = __webpack_public_path__ + "img/home_banner_slide_01.573e54f7.jpg";